// ClientsMarquee.jsx — три реда с логата на клиентите.
// Един спрайт: /public/clients-sprite.png (2000x638, retina 2x).
// Всяко лого има собствена ширина -> разстоянията помежду им са равни.

const SHEET_W = 1000;
const SHEET_H = 319;

const NAMES = ["042-restaurant", "akkodis", "alya-logo-final-1", "amatas", "amo-la-vita-logo", "amodoria", "artestroy", "baci-dolci", "bilateralstimulation", "braclinic-logo-700x460", "bulgariadent", "burger-joint", "contour", "deichmann", "denicomblueslogan", "eddyslogomascotrgb-v", "eko", "entain", "exoticarent", "forled", "groworking", "hans", "lidl", "logo-farms-png", "logo-zagorka-colored", "mastilnica", "mr-marlin", "multisport", "my24vet-logo", "nitram-logo-1", "nurident", "opitika-bg", "palms-bet", "premium-lightlogo-web", "puma", "quintessence", "resolute", "ring", "shelly", "smile", "starck", "the-mall", "tico-bar", "unnamed", "viber-image", "vip", "wd40-1", "world-class-cocktails", "zeisslogosvg", "вятърните-мелници", "къща-на-село"];

// [x, y, width, height] в CSS пиксели
const RECTS = [[0, 0, 68, 48], [72, 0, 64, 28], [140, 0, 51, 51], [195, 0, 127, 47], [326, 0, 33, 37], [363, 0, 145, 51], [512, 0, 68, 51], [584, 0, 98, 51], [686, 0, 146, 46], [837, 0, 147, 23], [0, 55, 162, 43], [166, 55, 44, 39], [214, 55, 161, 51], [380, 55, 42, 39], [426, 55, 126, 18], [556, 55, 71, 40], [631, 55, 34, 38], [669, 55, 121, 34], [794, 55, 75, 46], [0, 110, 150, 31], [154, 110, 160, 51], [318, 110, 31, 41], [353, 110, 37, 37], [395, 110, 41, 40], [440, 110, 101, 49], [545, 110, 45, 43], [594, 110, 78, 44], [677, 110, 136, 28], [817, 110, 86, 43], [908, 110, 46, 51], [0, 165, 135, 32], [139, 165, 153, 35], [296, 165, 89, 51], [389, 165, 95, 41], [489, 165, 80, 40], [573, 165, 162, 18], [740, 165, 126, 24], [870, 165, 64, 38], [0, 220, 134, 37], [138, 220, 162, 33], [304, 220, 116, 41], [425, 220, 67, 43], [496, 220, 70, 40], [571, 220, 162, 45], [737, 220, 153, 33], [895, 220, 42, 49], [0, 273, 56, 39], [60, 273, 162, 42], [227, 273, 112, 26], [343, 273, 147, 24], [494, 273, 66, 42]];

const ROWS = [
  { items: [18, 15, 48, 3, 24, 22, 27, 16, 33, 23, 41, 5, 47, 39, 46, 37, 29], duration: 46, reverse: false },
  { items: [4, 38, 10, 34, 21, 7, 1, 0, 36, 20, 25, 9, 6, 40, 11, 32, 35], duration: 54, reverse: true  },
  { items: [17, 31, 8, 13, 44, 45, 42, 26, 49, 14, 2, 19, 43, 30, 12, 50, 28], duration: 50, reverse: false },
];

function Logo({ i }) {
  const [x, y, w, h] = RECTS[i];
  return (
    <span
      role="img"
      aria-label={NAMES[i]}
      className="cm-logo"
      style={{
        width: `${w}px`,
        height: `${h}px`,
        backgroundImage: "url(/clients-sprite.png)",
        backgroundSize: `${SHEET_W}px ${SHEET_H}px`,
        backgroundPosition: `-${x}px -${y}px`,
      }}
    />
  );
}

export default function ClientsMarquee() {
  return (
    <div className="cm">
      {ROWS.map((r, n) => (
        <div className="cm-row" key={n}>
          <div
            className="cm-track"
            style={{
              animationDuration: `${r.duration}s`,
              animationDirection: r.reverse ? "reverse" : "normal",
            }}
          >
            {[...r.items, ...r.items].map((i, k) => <Logo i={i} key={k} />)}
          </div>
        </div>
      ))}
    </div>
  );
}
